/* Biohack World round 5
   - <bhw-ship>: free-shipping status that follows the store's real delivery rates
   - <bhw-clamp>: two-line titles with a Read More toggle */
(() => {
  /* Free-shipping thresholds, mirroring Settings > Shipping and delivery (General profile).
     [amount, currency]. Keep in sync if the delivery rates change. */
  const EUROPE = 'AX AL AD AT BY BE BA BG HR CZ DK EE FO FI FR GI GR GG VA HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE UA DE CH'.split(' ');
  const MIDDLE_EAST = 'SA AE JO KW OM QA YE'.split(' ');
  const rule = (country) => {
    if (country === 'GB') return [900, 'GBP'];
    if (country === 'IL') return [3000, 'ILS'];
    if (EUROPE.includes(country) || MIDDLE_EAST.includes(country) || country === 'CA' || country === 'MX') return [1000, 'USD'];
    return [100, 'USD']; // US, AU / NZ / SG and the International zone
  };

  /* Threshold in the shopper's currency, in minor units (cents), or null when it can't be worked out */
  const threshold = (country, currency) => {
    const [amount, base] = rule(String(country || '').toUpperCase());
    if (base === currency) return Math.round(amount * 100);
    const info = window.Shopify && window.Shopify.currency;
    const rate = info ? parseFloat(info.rate) : NaN;
    if (base === 'USD' && info && info.active === currency && rate > 0) return Math.round(amount * rate * 100);
    return null;
  };

  const money = (cents, currency) => {
    const whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  class BhwShip extends HTMLElement {
    static get observedAttributes() {
      return ['data-total', 'data-currency', 'data-country'];
    }

    connectedCallback() {
      this.update();
      // The cart re-renders by morphing; re-apply after any change to this element
      this.observer = new MutationObserver(() => {
        if (!this.busy) this.update();
      });
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    attributeChangedCallback() {
      if (this.isConnected) this.update();
    }

    set(el, html) {
      if (el && el.innerHTML !== html) el.innerHTML = html;
    }

    update() {
      this.busy = true;
      const total = parseInt(this.dataset.total || '0', 10);
      const currency = this.dataset.currency;
      const t = threshold(this.dataset.country, currency);
      const free = t !== null && total >= t;
      const mode = this.dataset.mode;
      this.classList.toggle('is-free', free);

      if (mode === 'row') {
        this.set(this, free ? 'Free' : 'Calculated at Checkout');
      } else if (mode === 'note') {
        if (t !== null) {
          this.set(this.querySelector('[data-title]'), free ? 'Ships Free' : `Free Shipping Over ${money(Math.ceil(t / 100) * 100, currency)}`);
        }
      } else {
        // bar
        if (t === null) {
          this.hidden = true;
        } else {
          this.hidden = false;
          const pct = free ? 100 : Math.max(4, Math.min(100, (total / t) * 100));
          this.set(
            this.querySelector('[data-text]'),
            free
              ? '<strong>Free shipping</strong> unlocked on your order'
              : `You're <strong>${money(t - total, currency)}</strong> away from free shipping`
          );
          const fill = this.querySelector('[data-fill]');
          if (fill) fill.style.width = `${pct}%`;
        }
      }
      queueMicrotask(() => {
        this.busy = false;
      });
    }
  }

  class BhwClamp extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.bhw-clamp__text');
      this.button = this.querySelector('.bhw-clamp__toggle');
      if (!this.text || !this.button) return;
      this.onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const open = this.toggleAttribute('open');
        this.button.textContent = open ? 'Show Less' : 'Read More';
        this.button.setAttribute('aria-expanded', String(open));
      };
      this.button.addEventListener('click', this.onClick);
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.text);
      this.measure();
    }

    disconnectedCallback() {
      if (this.resize) this.resize.disconnect();
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
    }

    measure() {
      if (this.hasAttribute('open')) return;
      this.button.hidden = !(this.text.scrollHeight > this.text.clientHeight + 2);
    }
  }

  /* Model comparison: on narrow screens, start the table scrolled to the model being viewed */
  const revealCurrentModel = () => {
    document.querySelectorAll('.bhw-compare__scroller').forEach((scroller) => {
      const current = scroller.querySelector('.bhw-compare__model.is-current');
      const pinned = scroller.querySelector('.bhw-compare__corner');
      if (!current || scroller.scrollWidth <= scroller.clientWidth + 2) return;
      const pinnedWidth = pinned ? pinned.offsetWidth : 0;
      const target = current.offsetLeft - pinnedWidth;
      if (current.offsetLeft + current.offsetWidth > scroller.clientWidth) scroller.scrollLeft = Math.max(0, target);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCurrentModel);
  else revealCurrentModel();

  if (!customElements.get('bhw-ship')) customElements.define('bhw-ship', BhwShip);
  if (!customElements.get('bhw-clamp')) customElements.define('bhw-clamp', BhwClamp);
})();
